import type { ListBuilderList } from '../../../types';
import { createShopStandardColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop At Risk list configuration
 * Items at risk in the client shop
 */
export const shopAtRiskList: ListBuilderList = {
	id: 'shop_at_risk',
	cacheTTL: 600000,
	name: 'At Risk',
	type: 'default',
	active: true,
	sortOrder: 2,
	columns: createShopStandardColumns(),
	description: 'Items at risk in the client shop',
	defaultSortId: 'column-item_details-asc',
	requiredFields: SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'at_risk',
					label: 'At Risk',
				},
			],
		},
	},
};
